import { Home } from "../../components/backgrounds/Home"

const contactDetails = [
    { name: 'Equipo de ayuda', email: 'ayuda@galilea.co' },
    { name: 'Gestión de PQRS', email: 'ayuda@galilea.co' },
    { name: 'Whatsapp', telephone: '(+57) 312 4008320' },
]
const locations = [
    { city: 'Bogotá', address: ['Calle 79 # 11 - 66 Edificio SPACES', 'Barrio El Nogal'] },
]

export function ContactPage() {
    return (
        <div className="bg-purpleLight">
            <Home title={'Contáctanos'} />
            <main>
                {/* Side-by-side grid */}
                <div className="bg-purpleLight">
                    <div className="max-w-md mx-auto py-8 px-4 sm:max-w-3xl sm:py-8 sm:px-6 lg:max-w-7xl lg:px-8">
                        <div className="divide-y divide-purple">
                            <section className="lg:grid lg:grid-cols-3 lg:gap-8 pt-20" aria-labelledby="contact-heading">
                                <h2 id="contact-heading" className="text-3xl font-bold sm:text-3xl">
                                    Canales de atención
                                    <h3 className='text-lg font-normal'>
                                        Horario: Días hábiles. Lunes a Viernes de 8:00 a.m a 5:00 p.m
                                    </h3>
                                </h2>
                                <div className="mt-8 grid grid-cols-1 gap-12 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-12 lg:mt-0 lg:col-span-2">
                                    {contactDetails.map((item) => (
                                        <div key={item.name}>
                                            <h3 className="text-xl font-bold text-warm-gray-900">{item.name}</h3>
                                            <dl className="mt-2 text-lg">
                                                <div>
                                                    <dt className="sr-only">Email</dt>
                                                    <dd>{item.email}</dd>
                                                </div>
                                                <div className="mt-1">
                                                    <dt className="sr-only">Phone number</dt>
                                                    <dd>{item.telephone}</dd>
                                                </div>
                                            </dl>
                                        </div>
                                    ))}
                                </div>
                            </section>
                            <section className="mt-16 py-16 lg:grid lg:grid-cols-3 lg:gap-8" aria-labelledby="location-heading">
                                <h2 id="location-heading" className="text-2xl font-bold text-warm-gray-900 sm:text-3xl">
                                    Oficinas
                                    <h3 className='text-lg font-normal'>
                                        Horario: Días hábiles. Lunes a Viernes de 9:00 a.m a 5:00 p.m
                                    </h3>
                                </h2>
                                <div className="mt-8 grid grid-cols-1 gap-12 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-12 lg:mt-0 lg:col-span-2">
                                    {locations.map((location) => (
                                        <div key={location.city}>
                                            <h3 className="text-xl font-bold text-warm-gray-900">{location.city}</h3>
                                            <div className="mt-2 text-lg space-y-1">
                                                {location.address.map((line) => (
                                                    <p key={line}>{line}</p>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                    <div>
                                        <h3>
                                            Nota importante: Las oficinas están habilitadas para recibir solicitudes en físico y correspondencia, NO hay atención presencial.
                                        </h3>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
/* import { useState } from 'react'
import { Switch } from '@headlessui/react'
import { MailIcon, PhoneIcon } from '@heroicons/react/outline'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export function ContactPage() {
    const [agreed, setAgreed] = useState(false)

    return (
        <div className="bg-white py-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-24">
            <div className="max-w-xl pt-10 mx-auto">
                <div className="text-center">
                    <h2 className="text-3xl font-medium tracking-tight sm:text-4xl">Contáctanos</h2>
                    <p className="mt-4 text-xl leading-6 text-gray-500">
                        Nuestro equipo de ayuda revisará tu solicitud y daremos respuesta en cuánto nos sea posible.
                    </p>
                </div>
                <div className="mt-12">
                    <form action="#" method="POST" className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
                        <div>
                            <label htmlFor="first-name" className="block text-sm font-medium">
                                Nombres
                            </label>
                            <div className="border-tdark border-opacity-40 focus-within:border-purple">
                                <input
                                    type="text"
                                    name="first-name"
                                    id="first-name"
                                    autoComplete="given-name"
                                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                                Apellidos
                            </label>
                            <div className="border-tdark border-opacity-40 focus-within:border-purple">
                                <input
                                    type="text"
                                    name="last-name"
                                    id="last-name"
                                    autoComplete="family-name"
                                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Correo electrónico
                            </label>
                            <div className="border-tdark border-opacity-40 focus-within:border-purple">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="phone-number" className="block text-sm font-medium text-gray-700">
                                Número de celular
                            </label>
                            <div className="mt-1 relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 flex items-center">
                                    <label htmlFor="country" className="sr-only">
                                        País
                                    </label>
                                    <select
                                        id="country"
                                        name="country"
                                        className="h-full py-0 pl-4 pr-8 border-transparent bg-transparent text-gray-500 focus:ring-transparent focus:border-purple rounded-md"
                                    >
                                        <option>COL (+57)</option>
                                    </select>
                                </div>
                                <input
                                    type="text"
                                    name="phone-number"
                                    id="phone-number"
                                    autoComplete="tel"
                                    className="py-2 px-4 pl-32 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                    placeholder="3028670523"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                                Mensaje
                            </label>
                            <div className="mt-1">
                                <textarea
                                    id="message"
                                    name="message"
                                    rows={4}
                                    className="py-3 px-4 block w-full shadow-sm focus:ring-transparent focus:border-purple border-gray-300 rounded-md"
                                    defaultValue={''}
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <div className="flex items-start">
                                <div className="flex-shrink-0">
                                    <Switch
                                        checked={agreed}
                                        onChange={setAgreed}
                                        className={classNames(
                                            agreed ? 'bg-red' : 'bg-red opacity-20',
                                            'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none'
                                        )}
                                    >
                                        <span className="sr-only">Tratamiento de datos</span>
                                        <span
                                            aria-hidden="true"
                                            className={classNames(
                                                agreed ? 'translate-x-5' : 'translate-x-0',
                                                'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                                            )}
                                        />
                                    </Switch>
                                </div>
                                <div className="ml-3">
                                    <p className="text-base">
                                        He leído y acepto el{' '}
                                        <a href="#" className="font-medium underline">
                                            Tratamiento de datos personales
                                        </a>{' '}
                                        y la{' '}
                                        <a href="#" className="font-medium underline">
                                            Política de privacidad
                                        </a>
                                        .
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <button
                                type="submit"
                                className="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-red transition duration-300 hover:bg-white hover:text-red hover:border-red focus:outline-none"
                            >
                                Enviar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="max-w-7xl mx-auto py-16 pt-36 px-4 sm:px-6 lg:px-8">
                <div className="max-w-lg mx-auto md:max-w-none md:grid md:grid-cols-2 md:gap-8">
                    <div>
                        <h2 className="text-2xl font-extrabold text-gray-900 sm:text-3xl">Sales Support</h2>
                        <div className="mt-3">
                            <p className="text-lg text-gray-500">
                                Nullam risus blandit ac aliquam justo ipsum. Quam mauris volutpat massa dictumst amet. Sapien tortor
                                lacus arcu.
                            </p>
                        </div>
                        <div className="mt-9">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <PhoneIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                                </div>
                                <div className="ml-3 text-base text-gray-500">
                                    <p>+1 (555) 123 4567</p>
                                    <p className="mt-1">Mon-Fri 8am to 6pm PST</p>
                                </div>
                            </div>
                            <div className="mt-6 flex">
                                <div className="flex-shrink-0">
                                    <MailIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                                </div>
                                <div className="ml-3 text-base text-gray-500">
                                    <p>support@example.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-12 sm:mt-16 md:mt-0">
                        <h2 className="text-2xl font-extrabold text-gray-900 sm:text-3xl">Technical Support</h2>
                        <div className="mt-3">
                            <p className="text-lg text-gray-500">
                                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Magni, repellat error corporis doloribus
                                similique, voluptatibus numquam quam, quae officiis facilis.
                            </p>
                        </div>
                        <div className="mt-9">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <PhoneIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                                </div>
                                <div className="ml-3 text-base text-gray-500">
                                    <p>+1 (555) 123 4567</p>
                                    <p className="mt-1">Mon-Fri 8am to 6pm PST</p>
                                </div>
                            </div>
                            <div className="mt-6 flex">
                                <div className="flex-shrink-0">
                                    <MailIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                                </div>
                                <div className="ml-3 text-base text-gray-500">
                                    <p>support@example.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
} */

/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  const colors = require('tailwindcss/colors')
  
  module.exports = {
    // ...
    theme: {
      extend: {
        colors: {
          'warm-gray': colors.warmGray,
          sky: colors.sky,
          cyan: colors.cyan,
        },
      },
    },
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/


